// NOTE: Not currently in use but didn't want to delete the file so we can revive later
import { Locales } from '@ratehub/base-ui';

import createBlogTagStaticProps from '../functions/createBlogTagStaticProps';
import withEnglishLocale from '../functions/withEnglishLocale';
import BlogTagPage from '../components/BlogTagPage';


const { getStaticPaths, getStaticProps } = createBlogTagStaticProps({
    locale: Locales.ENGLISH,
    fileName: 'blogTagEN', // Must match filename use for catch all, i.e. [...ccDetailsSlugEN].jsx
    path: '/blog/tag', // Array to determine the url - final result is `/${rootPath.join('/')}`
});

export default withEnglishLocale(BlogTagPage);
export { getStaticPaths, getStaticProps };
